import { render } from "./topic.vue?vue&type=template&id=573e0715&ts=true"
import script from "./topic.vue?vue&type=script&lang=ts"
export * from "./topic.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/topic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "573e0715"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('573e0715', __exports__)) {
    api.reload('573e0715', __exports__)
  }
  
  module.hot.accept("./topic.vue?vue&type=template&id=573e0715&ts=true", () => {
    api.rerender('573e0715', render)
  })

}


export default __exports__